export const februaryUppercase = "GiZT7c";
export default {februaryUppercase};